(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ff-plp"] && !Shopify.designMode) return;
  try {
    class FFPLP extends HTMLElement {
    connectedCallback() {
      this.confirmBar = this.querySelector('[data-plp-confirm]');
      this.confirmMessage = this.querySelector('[data-plp-confirm-message]');
      this.confirmCount = this.querySelector('[data-plp-confirm-count]');
      this.confirmSuffix = this.querySelector('[data-plp-confirm-suffix]');
      this.errorEl = this.querySelector('[data-plp-error]');

      this.addedCount = 0;

      this.grid = this.querySelector('[data-plp-grid]');
      this.loadMoreWrap = this.querySelector('[data-plp-load-more]');
      this.loadMoreLink = this.querySelector('[data-plp-load-more-link]');
      this.activeCollectionId = '';

      for (const chip of this.querySelectorAll('[data-plp-filter-chip]')) {
        chip.addEventListener('click', () => this.setActiveChip(chip));
      }

      this.initFiltersDrawer();
      this.initLoadMore();
      this.syncLoadMore();

      this.addEventListener('ff:plp:add-to-subscription', (event) => this.handleAdd(event));

      this.syncBoxState();
      this.correctSubscriptionStateIfWrong();
    }

    // plp_has_subscription (this file's own Liquid) decides whether EVERY product card on
    // the page even HAS an Add-to-box control at all -- ff-product-card.liquid wraps the
    // whole variant-selector-and-button block in an unless-hide_actions conditional, so when this
    // is wrong the markup is missing, not just mis-styled. That is a different, bigger
    // problem than sections/ff-header.liquid's circle-vs-pill swap or Box Builder's single
    // panel: there is no way to patch 180 product cards' worth of missing variant selectors,
    // per-variant metafield-sourced labels and subscription-discounted pricing back in from
    // JS without re-implementing a large, easy-to-drift-from-the-real-template slice of
    // ff-product-card.liquid a second time. So this takes a different approach entirely: if
    // a real client-side session says this customer IS actually subscribed but this element
    // was NOT rendered with data-plp-subscription-write, re-fetch this exact section through
    // Shopify's own Section Rendering API and swap in the REAL server-rendered HTML -- zero
    // duplicated logic, since it is the actual Liquid template, not an approximation of it.
    //
    // One-shot per page load via sessionStorage, not a JS-scoped flag: the swap replaces this
    // whole element, so a fresh one connects and runs this same method again. If the section
    // fetch reflects the correct state, hasAttribute() below is true the second time and this
    // returns immediately -- self-terminating. If the underlying cause turns out to NOT be
    // fixed by a fresh server request (e.g. it's edge-cache-based and the section endpoint is
    // cached the same way), the second attempt would try to fetch again -- so this guard
    // exists specifically to make it try at most once per page, not to handle the ordinary
    // already-correct case.
    //
    // FAF001P-155, confirmed live 2026-09-22: that one-shot guard must only cover the
    // section re-fetch below, never the client-side reconstruction that follows it. The
    // re-fetch depends on the classic `customer` object resolving server-side, which New
    // Customer Accounts never does for an ordinary page/section request on this store --
    // same request, same cookies, same wrong result every time (confirmed directly, even
    // with the Customer Account API access token attached as an Authorization header), so
    // retrying it on every page load would just repeat a known-futile network request
    // forever. Reconstruction has no such failure mode -- it is a plain, idempotent DOM
    // build from public catalogue data -- and `renderedSubscribed` below is FALSE on every
    // single page load for this store (the server-rendered attribute it reads never
    // becomes true), so gating it behind the same one-shot-per-pathname guard as the
    // re-fetch left every ordinary reload of the same page stuck showing browse-only cards
    // again, having "used up" its one attempt the first time. Confirmed live: reload the
    // exact same collection page a second time and the cards reverted with the guard in
    // place, then stayed fixed after moving it to cover only the re-fetch.
    // Reveals the server-rendered "Shop the range" sticky CTA -- hidden by default in markup
    // (see its own comment) specifically so a real subscriber never sees it flash up before
    // this method gets a chance to correct it. Only called from paths below that have
    // confirmed the CTA is the right thing to show; a confirmed subscriber's bar stays hidden
    // (reconstructCardActions() swaps it for the also-hidden confirm-bar markup instead), and
    // an unexpected error falls back to revealing it rather than leaving it invisible forever.
    revealStickyCta() {
      const bar = this.querySelector('[data-plp-sticky-cta]');
      if (bar) bar.hidden = false;
    }

    async correctSubscriptionStateIfWrong() {
      try {
        if (!(await window.ffWaitForAccountAuth())) { this.revealStickyCta(); return; }
        await window.FFAccountAuth.bootstrap();
        if (!window.FFAccountAuth.getAccessToken()) {
          this.revealStickyCta(); // genuinely anonymous — rendered state stands.
          return;
        }

        const reallySubscribed = await window.FFAccountAuth.hasActiveSubscription();
        const renderedSubscribed = this.hasAttribute('data-plp-subscription-write');
        if (!reallySubscribed || renderedSubscribed) {
          this.revealStickyCta(); // already correct, or correctly unsubscribed.
          return;
        }

        const sectionId = this.dataset.sectionId;
        const guardKey = 'ff-plp-section-corrected:' + window.location.pathname;
        let alreadyTriedRefetch = false;
        try {
          alreadyTriedRefetch = !!sessionStorage.getItem(guardKey);
        } catch (err) {
          alreadyTriedRefetch = true; // sessionStorage unavailable — treat as already tried, skip straight to reconstruction.
        }

        if (sectionId && !alreadyTriedRefetch) {
          try {
            sessionStorage.setItem(guardKey, '1');
          } catch (err) {}
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', sectionId);
          try {
            const resp = await fetch(url.toString());
            if (resp.ok) {
              const html = await resp.text();
              const parsed = new DOMParser().parseFromString(html, 'text/html');
              const fresh = parsed.querySelector('ff-plp');
              if (fresh && fresh.hasAttribute('data-plp-subscription-write')) {
                this.replaceWith(fresh);
                return;
              }
            }
          } catch (err) {
            // fall through to client-side reconstruction below.
          }
        }

        // Everything ff-product-card.liquid needs for this (variants, prices,
        // availability) is public catalogue data from Shopify's own
        // /products/<handle>.js, not customer data, so it needs no session beyond the one
        // already confirmed above.
        await this.reconstructCardActions();
      } catch (err) {
        // Silent — the server-rendered state, even if wrong, is already a complete, working page.
        // Still reveals the sticky CTA on the way out: an unexpected failure here must not
        // leave it hidden forever (worse than the occasional stale-but-functional guess this
        // file already tolerates everywhere else), and reconstructCardActions() swaps it out
        // entirely for a real subscriber before this would ever run for that case anyway.
        this.revealStickyCta();
      }
    }

    // Rebuilds the variant selector and Add-to-box controls `unless hide_actions` in
    // snippets/ff-product-card.liquid omitted entirely for every card on this page, one
    // card at a time. Sets
    // data-plp-subscription-write on THIS element too, not just a marker: mutate() in
    // ff-product-card.liquid keys its whole write-vs-redirect branch off
    // this.closest('[data-plp-subscription-write]'), and re-runs syncBoxState() afterwards
    // so the real Recharge box (not Shopify's cart, a different data source entirely for a
    // subscriber) fills in each variant's actual in-box quantity exactly as it would for a
    // page that rendered correctly from the start.
    // FAF001P-241: `appendOnly` is used after "Load more". The next page's cards come back from
    // the server in the same browse-only form as the first page did (the server cannot see the
    // New Customer Accounts session), so they need the same rebuild. It only touches cards that
    // still have no Add-to-box button, and skips the Recharge reset/re-sync at the end, which
    // the first call already did and applyBoxState() reuses.
    async reconstructCardActions({ appendOnly = false } = {}) {
      this.setAttribute('data-plp-subscription-write', '');

      const addLabel = this.dataset.addLabel || 'Add to box';
      const escapeHtml = (value) =>
        String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

      // The sticky bar has the exact same server-render split as the product cards: the
      // unless-plp_has_subscription branch above renders the "Shop the range" CTA, and its
      // else branch renders the "N items added" confirm bar (data-plp-confirm) INSTEAD of
      // it, as two different elements, not one toggled by
      // [hidden] -- so a wrong render doesn't just show the wrong bar, it means the confirm
      // bar this.confirmBar/confirmCount/confirmSuffix point at in connectedCallback()
      // never existed at all. showConfirmation() (called after every successful add) has
      // silently no-op'd on `if (!this.confirmBar) return;` this whole time -- confirmed
      // live 2026-09-22: an add-to-box wrote to Recharge correctly and the stepper updated,
      // but the sticky bar underneath kept showing "Shop the range" throughout, exactly as
      // if nothing had happened. Swap it for the real confirm-bar markup and rebind those
      // three refs, the same "insert what Liquid would have rendered, then rebind" pattern
      // as the per-card actions below.
      const stickyBar = this.querySelector('.ff-plp__sticky--cta');
      if (stickyBar) {
        stickyBar.outerHTML = `
          <div class="ff-plp__sticky ff-plp__sticky--confirm" data-plp-confirm role="status" aria-live="polite" hidden>
            <p class="ff-plp__confirm-message" data-plp-confirm-message>
              <span class="ff-plp__confirm-count" data-plp-confirm-count></span>
              <span class="ff-plp__confirm-suffix" data-plp-confirm-suffix>${escapeHtml(this.dataset.confirmSuffix || 'added to your box')}</span>
            </p>
            <a class="ff-plp__btn ff-plp__btn--primary ff-plp__sticky-cta" href="${escapeHtml(this.dataset.confirmCtaUrl || '/cart')}">
              ${escapeHtml(this.dataset.confirmCtaLabel || 'Review your box')}
            </a>
          </div>`;
        this.confirmBar = this.querySelector('[data-plp-confirm]');
        this.confirmMessage = this.querySelector('[data-plp-confirm-message]');
        this.confirmCount = this.querySelector('[data-plp-confirm-count]');
        this.confirmSuffix = this.querySelector('[data-plp-confirm-suffix]');
      }

      const wraps = [...this.querySelectorAll('[data-plp-grid-item]')].filter(
        (wrap) => !wrap.querySelector('[data-ff-add]')
      );

      await Promise.all(
        wraps.map(async (wrap) => {
          const card = wrap.querySelector('ff-product-card');
          const form = card?.querySelector('.ff-product-card__form');
          const meta = form?.querySelector('.ff-product-card__meta');
          const errorEl = form?.querySelector('.ff-product-card__error');
          if (!card || !form || !meta) return;

          let product;
          try {
            const resp = await fetch(`/products/${card.dataset.productHandle}.js`);
            if (!resp.ok) return;
            product = await resp.json();
          } catch (err) {
            return; // this one card stays browse-only — every other card still gets fixed.
          }

          const showOptions = !product.has_only_default_variant && product.variants.length > 1;
          const chosen = product.variants[0];

          const optionsMarkup = showOptions
            ? `<fieldset class="ff-product-card__options"><legend class="ff-product-card__options-legend">${escapeHtml(product.options[0] || '')}</legend>${product.variants
                .map(
                  (variant, i) => `
                <label class="ff-product-card__option${i === 0 ? ' ff-product-card__option--active' : ''}">
                  <input
                    class="ff-product-card__option-input"
                    type="radio"
                    name="id"
                    value="${variant.id}"
                    data-product-id="${product.id}"
                    data-in-cart="0"
                    data-line-key=""
                    data-available="${variant.available}"
                    ${i === 0 ? 'checked' : ''}
                    ${!variant.available ? 'disabled' : ''}
                  >
                  <span class="ff-product-card__option-label">${escapeHtml(variant.title)}</span>
                </label>`
                )
                .join('')}</fieldset>`
            : `<input type="hidden" name="id" value="${chosen.id}" data-product-id="${product.id}" data-in-cart="0" data-line-key="" data-available="${chosen.available}">`;

          const actionsMarkup = `
            <div class="ff-product-card__actions">
              <button class="ff-product-card__button" type="submit" data-ff-add ${!product.available ? 'disabled' : ''}>${escapeHtml(addLabel)}</button>
              <div class="ff-product-card__box" data-ff-box hidden>
                <div class="ff-product-card__stepper">
                  <button class="ff-product-card__step ff-product-card__step--down" type="button" data-ff-step="-1" aria-label="Decrease quantity">&minus;</button>
                  <span class="ff-product-card__qty" data-ff-qty aria-live="polite">0</span>
                  <button class="ff-product-card__step ff-product-card__step--up" type="button" data-ff-step="1" aria-label="Increase quantity">+</button>
                </div>
                <button class="ff-product-card__remove" type="button" data-ff-remove aria-label="Remove">&times;</button>
              </div>
            </div>`;

          meta.insertAdjacentHTML('beforebegin', optionsMarkup);
          if (errorEl) errorEl.insertAdjacentHTML('beforebegin', actionsMarkup);
          else form.insertAdjacentHTML('beforeend', actionsMarkup);

          card.rebindActions?.();
        })
      );

      if (appendOnly) return;

      this.rechargeAuth = null;
      this.boxSubscription = null;
      this.boxItems = null;
      await this.syncBoxState();
    }

    async syncBoxState() {
      if (!this.hasAttribute('data-plp-subscription-write')) return;

      try {
        if (!this.rechargeAuth) {
          const ready = await this.ensureRecharge();
          if (!ready) return;

          await window.recharge.init({
            storeIdentifier: this.dataset.shopDomain,
            storefrontAccessToken: this.dataset.storefrontAccessToken,
            appName: 'PLP',
            appVersion: '1.0.0',
          });

          // This store is on New Customer Accounts, which never sets the classic session
          // loginShopifyAppProxy() needs -- see snippets/ff-account-auth.liquid for why.
          if (!(await window.ffWaitForAccountAuth())) return;
          await window.FFAccountAuth.bootstrap();
          const auth = await window.FFAccountAuth.loginToRecharge();
          if (!auth?.customerId) return;
          this.rechargeAuth = auth;
        }

        if (!this.boxSubscription) {
          const { subscriptions } = await window.recharge.subscription.listSubscriptions(this.rechargeAuth, {
            customer_id: this.rechargeAuth.customerId,
            status: 'active',
          });
          this.boxSubscription = (subscriptions || []).find(
            (sub) => String(sub.external_product_id?.ecommerce) === String(this.dataset.boxProductId)
          );
        }
        if (!this.boxSubscription) return;

        if (!this.boxItems) {
          const { bundle_selections } = await window.recharge.bundle.listBundleSelections(this.rechargeAuth, {
            purchase_item_ids: String(this.boxSubscription.id),
          });
          this.bundleSelectionId = bundle_selections?.[0]?.id;
          this.boxItems = bundle_selections?.[0]?.items || [];
        }

        await this.applyBoxState();
      } catch (error) {
        console.error('[plp] could not sync box state', error);
      }
    }

    async applyBoxState() {
      if (!this.boxItems || !this.boxItems.length) return;

      if (window.customElements && !customElements.get('ff-product-card')) {
        await Promise.race([
          customElements.whenDefined('ff-product-card'),
          new Promise((resolve) => setTimeout(resolve, 5000)),
        ]);
      }

      for (const item of this.boxItems) {
        const variantId = String(item.external_variant_id?.ecommerce ?? item.external_variant_id ?? '');
        if (!variantId) continue;

        let input = null;
        try {
          input = this.querySelector(`[data-plp-grid-item] input[name="id"][value="${CSS.escape(variantId)}"]`);
        } catch (error) {
          continue;
        }
        if (!input) continue;

        input.dataset.inCart = String(item.quantity || 0);
        const card = input.closest('ff-product-card');
        const isActiveInput = input.type === 'radio' ? input.checked : true;
        if (card && isActiveInput && typeof card.render === 'function') card.render();
      }
    }

    async ensureRecharge(timeoutMs = 8000) {
      if (window.recharge && window.recharge.subscription) return true;

      if (!document.querySelector('[data-ff-recharge-sdk]')) {
        const script = document.createElement('script');
        script.src = `https://static.rechargecdn.com/assets/storefront/recharge-client-${this.dataset.sdkVersion}.min.js`;
        script.setAttribute('data-ff-recharge-sdk', '');
        document.head.appendChild(script);
      }

      const start = Date.now();
      while (!(window.recharge && window.recharge.subscription)) {
        if (Date.now() - start > timeoutMs) return false;
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      return true;
    }

    async ensureCollectionRules() {
      if (this.collectionRules) return this.collectionRules;
      const bundleData = await window.recharge.bundleData.loadBundleData(this.dataset.boxProductId);
      this.collectionRules = bundleData?.variants?.[0]?.collections || [];
      return this.collectionRules;
    }

    resolveCollectionId(candidateIds) {
      const rules = this.collectionRules || [];
      const withRule = candidateIds.find((id) => rules.some((rule) => String(rule.id) === id));
      if (withRule) return withRule;
      if (rules.length) return null;
      return candidateIds[0] || null;
    }

    async handleAdd(event) {
      const { variantId, quantity, onSuccess, onError } = event.detail;
      const handle = event.detail.productHandle;
      const wrap =
        event.target.closest('[data-plp-grid-item]') ||
        (handle
          ? this.querySelector(`[data-plp-grid-item] [data-product-handle="${CSS.escape(handle)}"]`)?.closest(
              '[data-plp-grid-item]'
            )
          : null);
      const productId = event.detail.productId || wrap?.dataset.productId;
      const candidateCollectionIds = (wrap?.dataset.ruleCollectionIds || '').split(',').filter(Boolean);

      let snapshot = null;

      try {
        if (!this.rechargeAuth) {
          const ready = await this.ensureRecharge();
          if (!ready) throw FFPLP.friendly('The subscription service is unavailable right now.');

          await window.recharge.init({
            storeIdentifier: this.dataset.shopDomain,
            storefrontAccessToken: this.dataset.storefrontAccessToken,
            appName: 'PLP',
            appVersion: '1.0.0',
          });

          // This store is on New Customer Accounts, which never sets the classic session
          // loginShopifyAppProxy() needs -- see snippets/ff-account-auth.liquid for why.
          if (!(await window.ffWaitForAccountAuth())) throw FFPLP.friendly('The subscription service is unavailable right now.');
          await window.FFAccountAuth.bootstrap();
          const auth = await window.FFAccountAuth.loginToRecharge();
          if (!auth?.customerId) throw FFPLP.friendly('We could not confirm your subscription.');
          this.rechargeAuth = auth;
        }

        if (!this.boxSubscription) {
          const { subscriptions } = await window.recharge.subscription.listSubscriptions(this.rechargeAuth, {
            customer_id: this.rechargeAuth.customerId,
            status: 'active',
          });
          this.boxSubscription = (subscriptions || []).find(
            (sub) => String(sub.external_product_id?.ecommerce) === String(this.dataset.boxProductId)
          );
        }
        if (!this.boxSubscription) throw FFPLP.friendly('We could not find your box subscription.');

        await this.ensureCollectionRules();
        const collectionId = this.resolveCollectionId(candidateCollectionIds);
        if (!collectionId) throw FFPLP.friendly('This product is not part of your box selection.');

        if (!this.boxItems) {
          const { bundle_selections } = await window.recharge.bundle.listBundleSelections(this.rechargeAuth, {
            purchase_item_ids: String(this.boxSubscription.id),
          });
          this.bundleSelectionId = bundle_selections?.[0]?.id;
          this.boxItems = bundle_selections?.[0]?.items || [];
        }

        snapshot = this.boxItems.map((item) => ({ ...item }));

        const kind = event.detail.kind === 'change' ? 'change' : 'add';
        const index = this.boxItems.findIndex(
          (item) => String(item.external_variant_id) === String(variantId)
        );
        const previous = index >= 0 ? Number(this.boxItems[index].quantity) || 0 : 0;
        const nextQuantity = kind === 'change' ? Math.max(0, quantity) : previous + Math.max(0, quantity);

        if (nextQuantity === previous) {
          onSuccess?.(previous);
          return;
        }

        if (nextQuantity === 0) {
          if (index >= 0) this.boxItems.splice(index, 1);
        } else if (index >= 0) {
          this.boxItems[index].quantity = nextQuantity;
        } else {
          this.boxItems.push({
            collection_id: collectionId,
            collection_source: 'shopify',
            external_product_id: productId,
            external_variant_id: variantId,
            quantity: nextQuantity,
          });
        }

        const payload = {
          purchase_item_id: this.boxSubscription.id,
          items: this.boxItems.map((item) => ({
            collection_id: item.collection_id,
            collection_source: item.collection_source || 'shopify',
            external_product_id: item.external_product_id,
            external_variant_id: item.external_variant_id,
            quantity: item.quantity,
          })),
        };
        const planId = await window.FFAccountAuth?.getRechargePlanId?.(this.boxSubscription, this.dataset.boxProductId);
        if (planId) payload.plan_id = planId;

        if (this.bundleSelectionId) {
          await window.recharge.bundle.updateBundleSelection(this.rechargeAuth, this.bundleSelectionId, payload);
        } else {
          const created = await window.recharge.bundle.createBundleSelection(this.rechargeAuth, payload);
          this.bundleSelectionId = created?.bundle_selection?.id || created?.id;
        }

        const delta = nextQuantity - previous;
        this.addedCount = Math.max(0, this.addedCount + delta);
        this.showConfirmation(delta);
        onSuccess?.(nextQuantity);
      } catch (error) {
        console.error('[plp] add to subscription failed', error);
        if (snapshot) this.boxItems = snapshot;
        const message = this.messageFor(error);
        this.setError(message);
        onError?.(message);
      }
    }

    setActiveChip(chip) {
      for (const other of this.querySelectorAll('[data-plp-filter-chip]')) {
        other.classList.toggle('ff-plp__filter-chip--active', other === chip);
      }

      this.activeCollectionId = chip.dataset.collectionId || '';
      this.applyFilter();

      for (const input of this.querySelectorAll('[data-plp-filters-option]')) {
        input.checked = input.dataset.collectionId === this.activeCollectionId;
      }

      this.syncLoadMore();
      this.autoLoadForActiveFilter();
    }

    // FAF001P-167, confirmed live 2026-09-24: a sub-category's members can be scattered
    // across the whole paginated catalog (this.grid only loads plp_product_limit products
    // at a time, default 12), but its chip count (chip.dataset.total) is real, sitewide
    // Shopify metadata -- so selecting a lower-volume category (e.g. "White Fish 12" on a
    // 26-product collection) could reveal only however many of its real members happened
    // to already be on the loaded page(s), 3 in the confirmed case, not the 12 the chip
    // claimed, with no indication more existed. "All" is left alone: its own "Load more"
    // already correctly represents "there's more, click for it" with no count to mismatch.
    async autoLoadForActiveFilter() {
      const targetId = this.activeCollectionId;
      if (!targetId) return;
      const total = Number(this.querySelector('[data-plp-filter-chip].ff-plp__filter-chip--active')?.dataset.total || 0);
      // loadNextPage() itself sets this.loadMoreLink to null once genuinely out of pages
      // (see its own nextLink check), so this can never spin forever even if `total`
      // overcounts against what's actually loadable.
      while (this.activeCollectionId === targetId && this.loadMoreLink && !this.loadingMore && this.loadedFor(targetId) < total) {
        await this.loadNextPage();
      }
    }

    applyFilter() {
      const id = this.activeCollectionId;
      for (const wrap of this.querySelectorAll('[data-plp-grid-item]')) {
        const matches = id === '' || `,${wrap.dataset.collectionIds}`.includes(`,${id},`);
        wrap.hidden = !matches;
      }
    }

    loadedFor(id) {
      const items = this.querySelectorAll('[data-plp-grid-item]');
      if (!id) return items.length;
      let count = 0;
      for (const wrap of items) {
        if (`,${wrap.dataset.collectionIds}`.includes(`,${id},`)) count += 1;
      }
      return count;
    }

    syncLoadMore() {
      if (!this.loadMoreWrap) return;
      const chip = this.querySelector('[data-plp-filter-chip].ff-plp__filter-chip--active');
      const total = Number(chip?.dataset.total || 0);
      const exhausted = total > 0 && this.loadedFor(this.activeCollectionId) >= total;
      this.loadMoreWrap.hidden = !this.loadMoreLink || exhausted;
    }

    initLoadMore() {
      if (!this.loadMoreLink) return;
      this.loadMoreLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.loadNextPage();
      });
    }

    async loadNextPage() {
      const link = this.loadMoreLink;
      const url = link?.getAttribute('href');
      if (!url || this.loadingMore) return;

      this.loadingMore = true;
      const label = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Loading…';

      try {
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`load more responded ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.querySelector('[data-plp-grid]');
        if (!nextGrid) throw new Error('no [data-plp-grid] in the fetched page');

        const fragment = document.createDocumentFragment();
        while (nextGrid.firstChild) fragment.appendChild(nextGrid.firstChild);
        this.grid.appendChild(fragment);

        // FAF001P-241: give the newly added cards their Add-to-box controls too when this page
        // is in subscriber mode. Without it only the first page of products had a CTA.
        if (this.hasAttribute('data-plp-subscription-write')) {
          await this.reconstructCardActions({ appendOnly: true });
        }

        const nextLink = doc.querySelector('[data-plp-load-more-link]');
        if (nextLink) {
          link.setAttribute('href', nextLink.getAttribute('href'));
        } else {
          this.loadMoreLink = null;
          this.loadMoreWrap?.remove();
          this.loadMoreWrap = null;
        }

        this.applyFilter();
        this.applyBoxState();
      } catch (error) {
        console.error('[plp] load more failed', error);
        this.setError('We could not load more products. Please try again.');
      } finally {
        if (this.loadMoreLink) {
          this.loadMoreLink.removeAttribute('aria-busy');
          this.loadMoreLink.textContent = label;
        }
        this.loadingMore = false;
        this.syncLoadMore();
      }
    }

    initFiltersDrawer() {
      const drawer = this.querySelector('[data-plp-filters-drawer]');
      const backdrop = this.querySelector('[data-plp-filters-backdrop]');
      if (!drawer || !backdrop) return;

      const openDrawer = () => {
        drawer.hidden = false;
        backdrop.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      const closeDrawer = () => {
        drawer.hidden = true;
        backdrop.hidden = true;
        document.body.style.removeProperty('overflow');
      };

      this.querySelectorAll('[data-plp-filter-toggle]').forEach((button) => {
        button.addEventListener('click', openDrawer);
      });
      backdrop.addEventListener('click', closeDrawer);
      drawer.querySelector('[data-plp-filters-close]')?.addEventListener('click', closeDrawer);
      drawer.querySelector('[data-plp-filters-apply]')?.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
      });

      drawer.querySelectorAll('[data-plp-filters-group-toggle]').forEach((header) => {
        header.addEventListener('click', () => {
          const expanded = header.getAttribute('aria-expanded') === 'true';
          header.setAttribute('aria-expanded', String(!expanded));
          const group = header.nextElementSibling;
          if (group) group.hidden = expanded;
        });
      });

      drawer.querySelectorAll('[data-plp-filters-option]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) {
            input.checked = true;
            return;
          }
          const chip = this.querySelector(`[data-plp-filter-chip][data-collection-id="${input.dataset.collectionId}"]`);
          if (chip) this.setActiveChip(chip);
        });
      });

      drawer.querySelector('[data-plp-filters-clear]')?.addEventListener('click', () => {
        const allChip = this.querySelector('[data-plp-filter-chip][data-collection-id=""]');
        if (allChip) this.setActiveChip(allChip);
      });
    }

    static friendly(message) {
      const error = new Error(message);
      error.ffFriendly = true;
      return error;
    }

    messageFor(error) {
      if (error?.ffFriendly && error.message) return error.message;
      return 'We could not update your box right now. Please try again.';
    }

    showConfirmation(delta = 1) {
      if (!this.confirmBar) return;

      if (this.confirmCount) {
        const added = delta > 0;
        const template = added
          ? this.dataset.confirmCountLabel || '[count] New items'
          : this.dataset.confirmRemovedLabel || 'Removed from your box';
        this.confirmCount.textContent = template.replace('[count]', String(this.addedCount));
        if (this.confirmSuffix) this.confirmSuffix.hidden = !added;
      }

      this.confirmBar.hidden = false;
      clearTimeout(this._confirmTimer);
      this._confirmTimer = setTimeout(() => {
        this.confirmBar.hidden = true;
      }, 4000);
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || 'We could not add that to your box. Please try again.';
      this.errorEl.hidden = false;
      clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => {
        this.errorEl.hidden = true;
      }, 4000);
    }
  }

  if (!customElements.get('ff-plp')) customElements.define('ff-plp', FFPLP);
  } catch(e) { console.error(e); }
})();

})();
